import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { REQUIRED } = ERROR_TYPE;

export const ManualCompanySchema = z.object({
	name: z.string().min(1, { message: REQUIRED }).trim(),
	websiteUrl: z.string().optional(),
	linkedinUrl: z.string().optional(),
});

export type ManualCompany = z.infer<typeof ManualCompanySchema>;
